import React, { Component, Fragment } from "react";

import { connect } from "react-redux";
import axios from "axios";
import classes from "../../LandingPage/PostOption/PostOption.module.css";
import toggeList from "../../../assets/svg/toggeList.svg";
import Map from "../../../Components/UI/Map/Map";
import * as actionCreator from "../../../Store/actions/index";
//CAR IMAGES:
import carimgOne from "../../../assets/Img/CarIcon/1.png";
import carimgTow from "../../../assets/Img/CarIcon/2.png";
import carimgThree from "../../../assets/Img/CarIcon/3.png";
//MOTOTR IMAGES:
import motorimgOne from "../../../assets/Img/MotorIcon/Motor1.png";
import motorimgTow from "../../../assets/Img/MotorIcon/Motor2.png";
import motorimgThree from "../../../assets/Img/MotorIcon/Motor3.png";
//COMMERCIAL IMAGES :
import commercialimgOne from "../../../assets/Img/commercial/commercialOne.png";
import commercialimgTow from "../../../assets/Img/commercial/commercialTwo.png";
import commercialimgThree from "../../../assets/Img/commercial/commercialThree.png";
// FORM ICONS:
import Hatchback from "../../../assets/svg/Hatchback.svg";
import Sedan from "../../../assets/svg/Sedan.svg";
import MUV from "../../../assets/svg/MUV.svg";
import Crossover from "../../../assets/svg/Crossover.svg";
import Coupe from "../../../assets/svg/Coupe.svg";
import SUV from "../../../assets/svg/SUV.svg";
import Convertible from "../../../assets/svg/Convertible.svg";
import Quadricycle from "../../../assets/svg/Quadricycle.svg";
import AMT from "../../../assets/svg/AMT.svg";
import Manual from "../../../assets/svg/Manual.svg";
import Automatic from "../../../assets/svg/Automatic.svg";
import Petrol from "../../../assets/svg/Petrol.svg";
import HybirdPetrol from "../../../assets/svg/Hybird&Petrol.svg";
import Electric from "../../../assets/svg/Electric.svg";
import Diesel from "../../../assets/svg/Diesel.svg";
import Gas from "../../../assets/svg/Gas.svg";
import Chopper from "../../../assets/svg/Chopper.svg";
import ATV from "../../../assets/svg/ATV.svg";
import Enduro from "../../../assets/svg/Enduro.svg";
import Scooter from "../../../assets/svg/Scooter.svg";
import Sport from "../../../assets/svg/Sport.svg";
import Street from "../../../assets/svg/Street.svg";
import Cross from "../../../assets/svg/Cross.svg";
import Cruiser from "../../../assets/svg/Cruiser.svg";
import SportTourist from "../../../assets/svg/SportTourist.svg";
import Underbone from "../../../assets/svg/Underbone.svg";
import Naked from "../../../assets/svg/Naked.svg";
import Touring from "../../../assets/svg/Touring.svg";
import Boat from "../../../assets/svg/Boat.svg";
import Bus from "../../../assets/svg/Bus.svg";
import Forklift from "../../../assets/svg/Forklift.svg";
import Lorry from "../../../assets/svg/Lorry.svg";
import Taxi from "../../../assets/svg/Taxi.svg";
import Tractor from "../../../assets/svg/Tractor.svg";
import Trailer from "../../../assets/svg/Trailer.svg";
import Van from "../../../assets/svg/Van.svg";
import Trike from "../../../assets/svg/Trike.svg";

const ICONS = {
  Hatchback: Hatchback,
  Sedan: Sedan,
  MUV: MUV,
  Crossover: Crossover,
  Coupe: Coupe,
  SUV: SUV,
  Convertible: Convertible,
  Quadricycle: Quadricycle,
  AMT: AMT,
  Manual: Manual,
  Automatic: Automatic,
  HybirdPetrol: HybirdPetrol,
  Electric: Electric,
  Petrol: Petrol,
  Diesel: Diesel,
  Gas: Gas,
  Chopper: Chopper,
  ATV: ATV,
  Enduro: Enduro,
  Scooter: Scooter,
  Sport: Sport,
  Street: Street,
  Cross: Cross,
  Cruiser: Cruiser,
  SportTourist: SportTourist,
  Underbone: Underbone,
  Naked: Naked,
  Touring: Touring,
  Boat: Boat,
  Bus: Bus,
  Forklift: Forklift,
  Lorry: Lorry,
  Taxi: Taxi,
  Tractor: Tractor,
  Trailer: Trailer,
  Van: Van,
  Trike: Trike,
};

const defaulImg = {
  carimgOne: carimgOne,
  carimgTow: carimgTow,
  carimgThree: carimgThree,
  motorimgOne: motorimgOne,
  motorimgTow: motorimgTow,
  motorimgThree: motorimgThree,
  commercialimgOne: commercialimgOne,
  commercialimgTow: commercialimgTow,
  commercialimgThree: commercialimgThree,
};

const BODY_TYPE = {
  Hatchback: "Hatchback",
  Sedan: "Sedan",
  MUV: "MUV",
  Crossover: "Crossover",
  Coupe: "Coupe",
  SUV: "SUV",
  Convertible: "Convertible",
  Quadricycle: "Quadricycle",
};

const MOTORS_BODY_TYPE = {
  Chopper: "Chopper",
  ATV: "ATV",
  Enduro: "Enduro",
  Scooter: "Scooter",
  Sport: "Sport",
  Street: "Street",
  Cross: "Cross",
  Cruiser: "Cruiser",
  SportTourist: "SportTourist",
  Underbone: "Underbone",
  Naked: "Naked",
  Touring: "Touring",
  Trike: "Trike",
};

const COMMERCIALS_BODY_TYPE = {
  Boat: "Boat",
  Bus: "Bus",
  Forklift: "Forklift",
  Lorry: "Lorry",
  Taxi: "Taxi",
  Tractor: "Tractor",
  Trailer: "Trailer",
  Van: "Van",
};

const TRANSMISSION = {
  AMT: "AMT",
  Manual: "Manual",
  Automatic: "Automatic",
};

const DREVIEN_WHEEL = {
  FourWD: "4WD",
  AWD: "AWD",
  FWD: "FWD",
  RWD: "RWD",
};

const FUEL_TYPE = {
  HybirdPetrol: "HybirdPetrol",
  Electric: "Electric",
  Petrol: "Petrol",
  Diesel: "Diesel",
};

const MOTORS_FUEL_TYPE = {
  Electric: "Electric",
  Petrol: "Petrol",
  Diesel: "Diesel",
};

const COMMERCIALS_FUEL_TYPE = {
  Petrol: "Petrol",
  Electric: "Electric",
  Gas: "Gas",
  Diesel: "Diesel",
};

class RentalOption extends Component {
  state = {
    //Coordinate:
    coords: null,
    //################## TOGGLING STATE:
    showVideos: true,
    showImages: true,
    showTechnical: true,
    //################## VIDEO STATE:
    video: {
      vidEdited: false,
      editedVidSrc: null,
      editedVidSize: null,
      editedVidType: null,
      eidtedVidFile: null,
    },
    //#################### IMAGES :
    baicsImgs: {
      imgOne: {
        imgEdited: false,
        editedImgSrc: null,
        name: "Image One",
        editName: "1",
      },
      imgTow: {
        imgEdited: false,
        editedImgSrc: null,
        name: "Image Tow",
        editName: "2",
      },
      imgThree: {
        imgEdited: false,
        editedImgSrc: null,
        name: "Image Three",
        editName: "3",
      },
    },
    optionalImg: {
      optionalImgOne: {
        imgEdited: false,
        editedImgSrc: null,
        editName: "4",
      },
      optionalImgTow: {
        imgEdited: false,
        editedImgSrc: null,
        editName: "5",
      },
      optionalImgThree: {
        imgEdited: false,
        editedImgSrc: null,
        editName: "6",
      },
    },
    // ############################## FIELDS VALUE :
    bodyType: this.props.postToEdit ? this.props.postToEdit.body_type : "",
    transmission: this.props.postToEdit
      ? this.props.postToEdit.transmission
      : "",
    drivenWheel: this.props.postToEdit
      ? this.props.postToEdit.driven_wheel
      : "",
    fuelType: this.props.postToEdit ? this.props.postToEdit.fuel_type : "",
    title: this.props.postToEdit ? this.props.postToEdit.title : "",
    sellerPitch: this.props.postToEdit
      ? this.props.postToEdit.seller_pitch
      : "",
    vehicle_make_id: this.props.postToEdit
      ? this.props.postToEdit.vehicle_make_id
      : "",
    vehicle_model_id: this.props.postToEdit
      ? this.props.postToEdit.vehicle_model_id
      : "",
    vehicle_variant_id: this.props.postToEdit
      ? this.props.postToEdit.vehicle_variant_id
      : "",
    monthly_price: this.props.postToEdit
      ? this.props.postToEdit.monthly_price
        ? this.props.postToEdit.monthly_price
        : ""
      : "",
    weekly_price: this.props.postToEdit
      ? this.props.postToEdit.weekly_price
        ? this.props.postToEdit.weekly_price
        : ""
      : "",
    daily_price: this.props.postToEdit
      ? this.props.postToEdit.daily_price
        ? this.props.postToEdit.daily_price
        : ""
      : "",
    hourly_price: this.props.postToEdit
      ? this.props.postToEdit.hourly_price
        ? this.props.postToEdit.hourly_price
        : ""
      : "",
    country_id: this.props.postToEdit ? this.props.postToEdit.country_id : "",
    state_id: this.props.postToEdit ? this.props.postToEdit.state_id : "",
    area_id: this.props.postToEdit ? this.props.postToEdit.area_id : "",

    // ############################### FETCHED ARRIES :
    makes: [],
    models: [],
    filterdModels: [],
    variants: [],
    filtredVariants: [],
    countries: [],
    states: [],
    areas: [],
    filterdStates: [],
    filterdAreas: [],
  };

  componentDidMount() {
    this.fetchVihecleMakeModelVariant(this.props.vihecleType);
    if (this.props.postToEdit) {
      this.ExistedImagesHandler();
    }
  }

  componentDidUpdate(prevProp) {
    if (prevProp.vihecleType !== this.props.vihecleType) {
      this.fetchVihecleMakeModelVariant(this.props.vihecleType);
    }
  }

  // ############################################# FETCHED ARRIES METHODS :

  fetchVihecleMakeModelVariant(type) {
    type = type.split("_")[0] + "s";
    axios
      .get(`${type}/makes`)
      .then((response) => {
        this.setState({ makes: response.data.data });
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(`${type}/models`)
      .then((response) => {
        this.setState({ models: response.data.data });
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(`${type}/variants`)
      .then((response) => {
        this.setState({ variants: response.data.data });
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(`countries`)
      .then((response) => {
        this.setState({ countries: response.data.data });
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(`states`)
      .then((response) => {
        this.setState({ states: response.data.data });
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(`areas`)
      .then((response) => {
        this.setState({ areas: response.data.data });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  selectMakesChangeHandler = (name, value) => {
    let updatedModels = [...this.state.models];
    updatedModels = updatedModels.filter((model) => {
      return model.vehicle_make_id === parseInt(value);
    });
    this.setState({
      filterdModels: updatedModels,
      filtredVariants: [],
      [`${name}`]: value,
    });
  };

  selectModelsChangedHandler = (name, value) => {
    let updatedVariants = [...this.state.variants];
    updatedVariants = updatedVariants.filter((variant) => {
      return variant.vehicle_model_id === parseInt(value);
    });
    this.setState({
      filtredVariants: updatedVariants,
      [`${name}`]: value,
    });
  };

  selectVariantsChangedHandler = (name, value) => {
    this.setState({
      [`${name}`]: value,
    });
  };

  selectCountryChangedHandler = (name, value) => {
    let updatedStates = [...this.state.states];
    updatedStates = updatedStates.filter((state) => {
      return state.country_id === parseInt(value);
    });
    this.setState({
      filterdStates: updatedStates,
      filterdAreas: [],
      [`${name}`]: value,
    });
  };

  selectStatesChangedHandler = (name, value) => {
    let updatedAreas = [...this.state.areas];
    updatedAreas = updatedAreas.filter((area) => {
      return area.state_id === parseInt(value);
    });
    this.setState({
      filterdAreas: updatedAreas,
      [`${name}`]: value,
    });
  };

  selectAreasChangedHandler = (name, value) => {
    this.setState({ [`${name}`]: value });
  };

  //######################    Toggel SEctions:
  toggelShowSection = (event, showMode) => {
    const position = event.pageY;
    this.setState((prevState) => {
      return {
        [`${showMode}`]: !prevState[`${showMode}`],
      };
    });
    const timO = setTimeout(() => {
      // window.scrollTo(0, position + 800)
      window.scrollTo({
        top: position,
        left: 0,
        behavior: "smooth",
      });
      this.clearTimeOut(timO);
    }, 100);
  };

  clearTimeOut = (timO) => {
    clearTimeout(timO);
  };

  //################ upload viedeo :
  uploadVideoHnadler = (event) => {
    const name = event.target.name;
    const file = event.target.files.item(0);
    let reader = new FileReader();
    let base46Img = null;
    const ImgTypes = [
      "video/mp4",
      "video/mkv",
      "video/flv",
      "video/mov",
      "video/wmv",
      "video/avi",
      "video/avchd",
      "video/webm",
    ];
    const currentImgUpdate = { ...this.state[`${name}`] };
    const validType = ImgTypes.some((type) => {
      if (file) {
        return file.type === type;
      } else return null;
    });
    if (validType && file.size < 100 * 1000000) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        base46Img = reader.result;
        currentImgUpdate.vidEdited = true;
        currentImgUpdate.editedVidSrc = base46Img;
        currentImgUpdate.eidtedVidFile = file;
        currentImgUpdate.editedVidType = file.type;
        this.setState({ [`${name}`]: currentImgUpdate });
      };
    }
  };

  //################## image Handler
  uploadImageHandler = (event, optional) => {
    const currentImg = event.target.name;
    const file = event.target.files.item(0);
    let reader = new FileReader();
    let base46Img = null;
    const ImgTypes = ["image/jpeg", "image/png", "image/gif"];
    const validType = ImgTypes.some((type) => {
      if (file) {
        return file.type === type;
      } else return null;
    });
    let currentImgArray;
    if (!optional) {
      currentImgArray = { ...this.state.baicsImgs };
    } else {
      currentImgArray = { ...this.state.optionalImg };
    }
    const currentImgUpdate = { ...currentImgArray[`${event.target.name}`] };

    if (validType) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        base46Img = reader.result;
        currentImgUpdate.imgEdited = true;
        currentImgUpdate.editedImgSrc = base46Img;
        currentImgArray[`${currentImg}`] = currentImgUpdate;
        if (!optional) {
          this.setState({ baicsImgs: currentImgArray });
        } else {
          this.setState({ optionalImg: currentImgArray });
        }
      };
    }
  };

  //###############  Upload All
  stateImgFinder = (numb) => {
    switch (numb) {
      case 0:
        return "imgOne";
      case 1:
        return "imgTow";
      case 2:
        return "imgThree";
      default:
        return null;
    }
  };

  uploadAllHAndler = (event) => {
    let files = event.target.files;
    const currentImgArray = { ...this.state.baicsImgs };
    for (let i = 0; i < files.length; i++) {
      if (i >= 3) {
        break;
      } else {
        let file = files[i];
        let reader = new FileReader();
        let base46Img = null;
        let stateImg = this.stateImgFinder(i);
        const ImgTypes = ["image/jpeg", "image/png", "image/gif"];
        const validType = ImgTypes.some((type) => {
          if (file) {
            return file.type === type;
          } else return null;
        });

        const currentImgUpdate = { ...currentImgArray[`${stateImg}`] };

        if (validType) {
          reader.readAsDataURL(file);
          reader.onload = () => {
            base46Img = reader.result;
            currentImgUpdate.imgEdited = true;
            currentImgUpdate.editedImgSrc = base46Img;
            currentImgArray[`${stateImg}`] = currentImgUpdate;
            this.setState({ baicsImgs: currentImgArray });
          };
        }
      }
    }
  };

  // ####################### Existed Images :
  nestedStateUpdater = (basic, editName, content) => {
    let updatedBasicImgs = null;
    if (basic) {
      updatedBasicImgs = { ...this.state.baicsImgs };
    } else {
      updatedBasicImgs = { ...this.state.optionalImg };
    }
    const key = Object.entries(updatedBasicImgs).filter((img) => {
      if (editName === img[1].editName) {
        return img;
      } else return null;
    })[0][0];
    const updateImg = { ...updatedBasicImgs[`${key}`] };
    updateImg.editedImgSrc = content;
    return [key, updateImg];
  };

  ExistedImagesHandler = () => {
    const updateImg = {},
      updateOpt = { ...this.state.optionalImg };
    if (this.props.postToEdit) {
      this.props.postToEdit.media.forEach((mediaEle) => {
        if (mediaEle.name === "video") {
          const video = { ...this.state.video };
          video.editedVidSrc = mediaEle.url;
          this.setState({ video: video });
        } else if (+mediaEle.name < 4) {
          const [key, val] = this.nestedStateUpdater(
            true,
            mediaEle.name,
            mediaEle.url
          );
          updateImg[`${key}`] = val;
        } else if (+mediaEle.name > 3) {
          const [key, val] = this.nestedStateUpdater(
            false,
            mediaEle.name,
            mediaEle.url
          );
          updateOpt[`${key}`] = val;
        }
      });
      this.setState({ baicsImgs: updateImg, optionalImg: updateOpt });
    }
  };

  // ################ Form Methods:

  setCoordinateHandler = (coords) => {
    this.setState({ coords: coords });
  };

  inputChangeHandler = (name, value) => {
    this.setState({ [`${name}`]: value });
  };

  formSubmitHandler = (event) => {
    event.preventDefault();
    const valuesArray = [];
    const errorArray = [];
    const rateArr = [
      this.state.hourly_price,
      this.state.daily_price,
      this.state.weekly_price,
      this.state.monthly_price,
    ];
    valuesArray.push(
      { "body Type": this.state.bodyType },
      { Transmission: this.state.transmission },
      { "Driven wheel": this.state.drivenWheel },
      { "Fuel Type": this.state.fuelType },
      { Rate: rateArr.join(" ") },
      { Title: this.state.title },
      { "Seller Pitch": this.state.sellerPitch },
      { "Make/Brand": this.state.vehicle_make_id },
      { Model: this.state.vehicle_model_id },
      { Variant: this.state.vehicle_variant_id },
      { Country: this.state.country_id },
      { State: this.state.state_id },
      { Area: this.state.area_id }
    );
    if (this.props.vihecleType === "motor_rentals") {
      valuesArray.splice(1, 2);
    }
    if (this.props.vihecleType === "commercial_rentals") {
      valuesArray.splice(2, 1);
    }
    Object.values(this.state.baicsImgs).forEach((img) => {
      valuesArray.push({ [`${img.name}`]: img.editedImgSrc });
    });
    valuesArray.map((ele) => {
      return Object.entries(ele).map((val) => {
        if (typeof val[1] === "string") {
          if (val[1].trim() === "") {
            errorArray.push(val[0]);
          }
        } else if (!val[1]) {
          errorArray.push(val[0]);
        }
        return errorArray;
      });
    });
    window.scrollTo(0, 0);
    const errorMess =
      "Please provid values for the following fields :\n" +
      errorArray.join("\n");
    if (errorArray.length > 0) {
      this.props.errorModalHandler(errorMess);
    } else {
      this.searchUrlConstructor();
    }
  };

  searchUrlConstructor = () => {
    const data = {
        body_type: this.state.bodyType,
        transmission: this.state.transmission,
        driven_wheel: this.state.drivenWheel,
        fuel_type: this.state.fuelType,
        title: this.state.title,
        seller_pitch: this.state.sellerPitch,
        vehicle_make_id: this.state.vehicle_make_id,
        vehicle_model_id: this.state.vehicle_model_id,
        vehicle_variant_id: this.state.vehicle_variant_id,
        monthly_price: this.state.monthly_price,
        weekly_price: this.state.weekly_price,
        daily_price: this.state.daily_price,
        hourly_price: this.state.hourly_price,
        country_id: this.state.country_id,
        state_id: this.state.state_id,
        area_id: this.state.area_id,
        is_published: 0,
        ...this.state.coords,
      },
      mediaData = {},
      video = this.state.video.eidtedVidFile,
      optionalStart = 4;
    let media = [],
      vidMedia = null;
    Object.values(this.state.baicsImgs).forEach((img, i) => {
      if (img.imgEdited) {
        media.push({
          name: i + 1,
          content: img.editedImgSrc,
        });
      }
    });
    Object.values(this.state.optionalImg).forEach((img, i) => {
      if (img.editedImgSrc && img.imgEdited) {
        media.push({
          name: optionalStart + i,
          content: img.editedImgSrc,
        });
      }
    });
    if (video) {
      if (this.state.video.vidEdited) {
        vidMedia = {
          name: "video",
          content: video,
        };
      }
      media.push(vidMedia);
    }

    if (this.props.postToEdit) {
      mediaData.media = media;
      const postId = localStorage.getItem("draftId");
      let type = this.props.vihecleType;
      if (mediaData.media.length) {
        this.props.onSaveEditedPost(type, postId, data, mediaData, vidMedia);
      } else {
        this.props.onSaveEditedPost(type, postId, data, null, vidMedia);
      }
    } else {
      mediaData.media = media;
      this.props.onAddServiceToDraft(this.props.vihecleType, data, mediaData);
    }
    this.props.history.push("/Preview");
  };

  // ######################## RENDER
  // ######################## RENDER
  // ######################## RENDER

  render() {
    const VideoWraperClasses = this.state.showVideos
      ? `${classes.VideoWraper}`
      : `${classes.Hide}`;

    const ImgWraperClasses = this.state.showImages
      ? `${classes.ImgWraper}`
      : `${classes.Hide}`;

    const formOptionsClasses = this.state.showTechnical
      ? `${classes.formOptions}`
      : `${classes.Hide}`;

    return (
      <div className={classes.SearchOptions}>
        {/*#################################################################################### VIDEOS */}
        <div
          className={classes.SectionToggler}
          onClick={(event) => {
            this.toggelShowSection(event, "showVideos");
          }}
        >
          <h2 className="mt-5">
            <img src={toggeList} alt="toggel" />
            Upload your listing video{" "}
          </h2>
          <p className={classes.underTitle}>
            Listings with video is proven to sell faster
          </p>
        </div>
        <div className={VideoWraperClasses}>
          <div className={classes.ProfilePic}>
            <video
              controlsList="nodownload"
              controls
              src={this.state.video.editedVidSrc}
              height="200px"
            >
              Sorry, your browser doesn't support embedded videos.
            </video>
            <label>
              <input
                type="file"
                name="video"
                onChange={(event) => this.uploadVideoHnadler(event)}
              />
              Upload
            </label>
          </div>
        </div>
        {/*#################################################################################### IMAGES */}
        <div
          className={classes.SectionToggler}
          onClick={(event) => {
            this.toggelShowSection(event, "showImages");
          }}
        >
          <h2 className="mt-5">
            <img src={toggeList} alt="toggel" />
            Upload your vehicle images{" "}
          </h2>
          <div className={ImgWraperClasses}>
            <p className={classes.underTitle}>
              We have provided you with a recommended photo styles to help you
              sell faster.
            </p>
            <div className={classes.UploadAll}>
              <p className={classes.underTitle}>
                Select Multiple picture altogether at once
              </p>
              <label>
                <input
                  type="file"
                  name="uploadAll"
                  multiple
                  onChange={(event) => this.uploadAllHAndler(event)}
                />
                Bulk Upload
              </label>
            </div>
            {Object.entries(this.state.baicsImgs).map((img) => {
              let type = this.props.vihecleType.split("_")[0];
              let currentImg = null;
              if (img[1].editedImgSrc) {
                currentImg = <img src={img[1].editedImgSrc} alt="Service" />;
              }
              return (
                <div key={img[0]} className={classes.ProfilePic}>
                  {currentImg ? (
                    currentImg
                  ) : (
                    <img
                      src={defaulImg[`${type}${img[0]}`]}
                      alt={`car${img[0]}`}
                    />
                  )}
                  <label>
                    <input
                      type="file"
                      name={img[0]}
                      onChange={(event) => {
                        this.uploadImageHandler(event);
                      }}
                    />
                    Upload
                  </label>
                </div>
              );
            })}
            {Object.entries(this.state.optionalImg).map((img) => {
              let currentImg = null;
              if (img[1].editedImgSrc) {
                currentImg = <img src={img[1].editedImgSrc} alt="Service" />;
              }
              return (
                <div key={img[0]} className={classes.ProfilePic}>
                  {currentImg ? currentImg : <p>Optional image</p>}
                  <label>
                    <input
                      type="file"
                      name={img[0]}
                      onChange={(event) => {
                        this.uploadImageHandler(event, true);
                      }}
                    />
                    Upload
                  </label>
                </div>
              );
            })}
          </div>
        </div>
        <div
          className={classes.SectionToggler}
          onClick={(event) => {
            this.toggelShowSection(event, "showTechnical");
          }}
        >
          <h2 className="mt-5">
            <img src={toggeList} alt="toggel" />
            Vehicle informaition
          </h2>
        </div>

        {/*################################################## form Option */}
        {/*################################################## form Option */}
        {/*################################################## form Option */}

        <div className={formOptionsClasses}>
          <form
            onSubmit={(event) => {
              this.formSubmitHandler(event);
            }}
          >
            <p className="mt-3">BODY TYPE</p>
            <div className={classes.BodyTypes}>
              {this.props.vihecleType === "car_rentals"
                ? Object.values(BODY_TYPE).map((bodyT) => {
                    return (
                      <Fragment key={bodyT}>
                        <input
                          value={`${bodyT}`}
                          type="radio"
                          name="bodyType"
                          id={`${bodyT}`}
                          defaultChecked={
                            this.props.postToEdit
                              ? this.props.postToEdit.body_type === bodyT
                                ? true
                                : false
                              : false
                          }
                          onChange={(event) => {
                            this.inputChangeHandler(
                              event.target.name,
                              event.target.value
                            );
                          }}
                        />
                        <label
                          className={classes.SmallFont}
                          htmlFor={`${bodyT}`}
                        >
                          <img
                            src={ICONS[`${bodyT}`]}
                            alt={`${bodyT}`}
                            style={{ marginBottom: "6px" }}
                          />
                          {bodyT}
                        </label>
                      </Fragment>
                    );
                  })
                : this.props.vihecleType === "motor_rentals"
                ? Object.values(MOTORS_BODY_TYPE).map((bodyT) => {
                    return (
                      <Fragment key={bodyT}>
                        <input
                          value={`${bodyT}`}
                          type="radio"
                          name="bodyType"
                          id={`${bodyT}`}
                          defaultChecked={
                            this.props.postToEdit
                              ? this.props.postToEdit.body_type === bodyT
                                ? true
                                : false
                              : false
                          }
                          onChange={(event) => {
                            this.inputChangeHandler(
                              event.target.name,
                              event.target.value
                            );
                          }}
                        />
                        <label
                          className={classes.SmallFont}
                          htmlFor={`${bodyT}`}
                        >
                          <img
                            src={ICONS[`${bodyT}`]}
                            alt={`${bodyT}`}
                            style={{ width: "40px", marginBottom: "6px" }}
                          />
                          {bodyT}
                        </label>
                      </Fragment>
                    );
                  })
                : this.props.vihecleType === "commercial_rentals"
                ? Object.values(COMMERCIALS_BODY_TYPE).map((bodyT) => {
                    return (
                      <Fragment key={bodyT}>
                        <input
                          value={`${bodyT}`}
                          type="radio"
                          name="bodyType"
                          id={`${bodyT}`}
                          defaultChecked={
                            this.props.postToEdit
                              ? this.props.postToEdit.body_type === bodyT
                                ? true
                                : false
                              : false
                          }
                          onChange={(event) => {
                            this.inputChangeHandler(
                              event.target.name,
                              event.target.value
                            );
                          }}
                        />
                        <label
                          className={classes.SmallFont}
                          htmlFor={`${bodyT}`}
                        >
                          <img
                            src={ICONS[`${bodyT}`]}
                            alt={`${bodyT}`}
                            style={{ marginBottom: "6px" }}
                            width="25px"
                          />
                          {bodyT}
                        </label>
                      </Fragment>
                    );
                  })
                : null}
            </div>
            {(this.props.vihecleType === "car_rentals" ||
              this.props.vihecleType === "commercial_rentals") && (
              <Fragment>
                <p className="mt-3">Transmission</p>
                <div className={classes.BodyTypes}>
                  {Object.values(TRANSMISSION).map((tran) => {
                    return (
                      <Fragment key={tran}>
                        <input
                          value={tran}
                          type="radio"
                          name="transmission"
                          id={tran}
                          defaultChecked={
                            this.props.postToEdit
                              ? this.props.postToEdit.transmission === tran
                                ? true
                                : false
                              : false
                          }
                          onChange={(event) => {
                            this.inputChangeHandler(
                              event.target.name,
                              event.target.value
                            );
                          }}
                        />
                        <label htmlFor={tran}>
                          <img src={ICONS[`${tran}`]} alt={tran} />
                          {tran}
                        </label>
                      </Fragment>
                    );
                  })}
                </div>
              </Fragment>
            )}
            {this.props.vihecleType === "car_rentals" && (
              <Fragment>
                <p className="mt-3">Driven Wheel</p>
                <div className={classes.DrivenW}>
                  {Object.values(DREVIEN_WHEEL).map((dWheel) => {
                    return (
                      <Fragment key={dWheel}>
                        <input
                          value={dWheel}
                          type="radio"
                          name="drivenWheel"
                          id={dWheel}
                          defaultChecked={
                            this.props.postToEdit
                              ? this.props.postToEdit.driven_wheel === dWheel
                                ? true
                                : false
                              : false
                          }
                          onChange={(event) => {
                            this.inputChangeHandler(
                              event.target.name,
                              event.target.value
                            );
                          }}
                        />
                        <label htmlFor={dWheel}>{dWheel}</label>
                      </Fragment>
                    );
                  })}
                </div>
              </Fragment>
            )}
            <p className="mt-3">Fuel Type</p>
            <div className={classes.BodyTypes}>
              {this.props.vihecleType === "car_rentals"
                ? Object.values(FUEL_TYPE).map((fuelT) => {
                    return (
                      <Fragment key={fuelT}>
                        <input
                          value={fuelT}
                          type="radio"
                          name="fuelType"
                          id={fuelT}
                          defaultChecked={
                            this.props.postToEdit
                              ? this.props.postToEdit.fuel_type === fuelT
                                ? true
                                : false
                              : false
                          }
                          onChange={(event) => {
                            this.inputChangeHandler(
                              event.target.name,
                              event.target.value
                            );
                          }}
                        />
                        <label htmlFor={fuelT}>
                          <img src={ICONS[`${fuelT}`]} alt={fuelT} />
                          {fuelT}
                        </label>
                      </Fragment>
                    );
                  })
                : this.props.vihecleType === "motor_rentals"
                ? Object.values(MOTORS_FUEL_TYPE).map((fuelT) => {
                    return (
                      <Fragment key={fuelT}>
                        <input
                          value={fuelT}
                          type="radio"
                          name="fuelType"
                          id={fuelT}
                          defaultChecked={
                            this.props.postToEdit
                              ? this.props.postToEdit.fuel_type === fuelT
                                ? true
                                : false
                              : false
                          }
                          onChange={(event) => {
                            this.inputChangeHandler(
                              event.target.name,
                              event.target.value
                            );
                          }}
                        />
                        <label htmlFor={fuelT}>
                          <img src={ICONS[`${fuelT}`]} alt={fuelT} />
                          {fuelT}
                        </label>
                      </Fragment>
                    );
                  })
                : this.props.vihecleType === "commercial_rentals"
                ? Object.values(COMMERCIALS_FUEL_TYPE).map((fuelT) => {
                    return (
                      <Fragment key={fuelT}>
                        <input
                          value={fuelT}
                          type="radio"
                          name="fuelType"
                          id={fuelT}
                          defaultChecked={
                            this.props.postToEdit
                              ? this.props.postToEdit.fuel_type === fuelT
                                ? true
                                : false
                              : false
                          }
                          onChange={(event) => {
                            this.inputChangeHandler(
                              event.target.name,
                              event.target.value
                            );
                          }}
                        />
                        <label htmlFor={fuelT}>
                          <img src={ICONS[`${fuelT}`]} alt={fuelT} />
                          {fuelT}
                        </label>
                      </Fragment>
                    );
                  })
                : null}
            </div>
            <p className="mt-3" className="mt-3">
              Rates
            </p>
            <small style={{ color: "red" }}>
              (add at least one type of rates)
            </small>
            <div className={classes.SelectNinputWraper}>
              <div className={classes.SearchNinputElementWraper}>
                <p className="mt-3">Per Hour (RM)</p>
                <input
                  className={classes.textInput}
                  type="number"
                  placeholder="Per hour RM"
                  value={this.state.hourly_price}
                  onChange={(event) => {
                    this.setState({ hourly_price: event.target.value });
                  }}
                />
              </div>
              <div className={classes.SearchNinputElementWraper}>
                <p className="mt-3">Per Day (RM)</p>
                <input
                  className={classes.textInput}
                  type="number"
                  placeholder="Per day RM"
                  value={this.state.daily_price}
                  onChange={(event) => {
                    this.setState({ daily_price: event.target.value });
                  }}
                />
              </div>
              <div className={classes.SearchNinputElementWraper}>
                <p className="mt-3">Per Week (RM)</p>
                <input
                  className={classes.textInput}
                  type="number"
                  placeholder="Per week RM"
                  value={this.state.weekly_price}
                  onChange={(event) => {
                    this.setState({ weekly_price: event.target.value });
                  }}
                />
              </div>
              <div className={classes.SearchNinputElementWraper}>
                <p className="mt-3">Per Month (RM)</p>
                <input
                  className={classes.textInput}
                  type="number"
                  placeholder="Per Month RM"
                  value={this.state.monthly_price}
                  onChange={(event) => {
                    this.setState({ monthly_price: event.target.value });
                  }}
                />
              </div>
            </div>
            <div className={classes.SearchNinputElementWraper}>
              <p className="mt-3">Title</p>
              <input
                ref={this.optionRef}
                className={classes.textInput}
                type="text"
                placeholder="Title"
                value={this.state.title}
                onChange={(event) => {
                  this.setState({ title: event.target.value });
                }}
              />
            </div>
            <p className="mt-3">Seller Pitch</p>
            <textarea
              placeholder="seller Pitch"
              value={this.state.sellerPitch}
              onChange={(event) => {
                this.setState({ sellerPitch: event.target.value });
              }}
            />
            <div className={classes.SelectNinputWraper}>
              <div className={classes.SearchNinputElementWraper}>
                <p className="mt-3">Make</p>
                <select
                  name="vehicle_make_id"
                  onChange={(event) => {
                    this.selectMakesChangeHandler(
                      event.target.name,
                      event.target.value
                    );
                  }}
                >
                  <option
                    value={
                      this.props.postToEdit
                        ? this.props.postToEdit.vehicle_make.id
                        : ""
                    }
                  >
                    {this.props.postToEdit
                      ? this.props.postToEdit.vehicle_make.name
                      : "Make / Brands"}
                  </option>
                  {this.state.makes.map((option) => {
                    return (
                      <option key={option.id} value={option.id}>
                        {" "}
                        {option.name}{" "}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className={classes.SearchNinputElementWraper}>
                <p className="mt-3">Model</p>
                <select
                  name="vehicle_model_id"
                  onChange={(event) => {
                    this.selectModelsChangedHandler(
                      event.target.name,
                      event.target.value
                    );
                  }}
                >
                  <option
                    value={
                      this.props.postToEdit
                        ? this.props.postToEdit.vehicle_model.id
                        : ""
                    }
                  >
                    {this.props.postToEdit
                      ? this.props.postToEdit.vehicle_model.name
                      : "Models"}
                  </option>
                  {this.state.filterdModels.map((model) => {
                    return (
                      <option key={model.id} value={model.id}>
                        {model.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className={classes.SearchNinputElementWraper}>
                <p className="mt-3">Variant</p>
                <select
                  name="vehicle_variant_id"
                  onChange={(event) => {
                    this.selectVariantsChangedHandler(
                      event.target.name,
                      event.target.value
                    );
                  }}
                >
                  <option
                    value={
                      this.props.postToEdit
                        ? this.props.postToEdit.vehicle_variant.id
                        : ""
                    }
                  >
                    {this.props.postToEdit
                      ? this.props.postToEdit.vehicle_variant.name
                      : "Variants"}
                  </option>
                  {this.state.filtredVariants.map((variant) => {
                    return (
                      <option key={variant.id} value={variant.id}>
                        {variant.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className={classes.SearchNinputElementWraper}>
                <p className="mt-3">Country</p>
                <select
                  name="country_id"
                  onChange={(event) => {
                    this.selectCountryChangedHandler(
                      event.target.name,
                      event.target.value
                    );
                  }}
                >
                  <option
                    value={
                      this.props.postToEdit
                        ? this.props.postToEdit.country.id
                        : ""
                    }
                  >
                    {this.props.postToEdit
                      ? this.props.postToEdit.country.name
                      : "Country"}
                  </option>
                  {this.state.countries.map((option) => {
                    return (
                      <option key={option.id} value={option.id}>
                        {option.name}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className={classes.SearchNinputElementWraper}>
                <p className="mt-3">State</p>
                <select
                  name="state_id"
                  onChange={(event) => {
                    this.selectStatesChangedHandler(
                      event.target.name,
                      event.target.value
                    );
                  }}
                >
                  <option
                    value={
                      this.props.postToEdit
                        ? this.props.postToEdit.state.id
                        : ""
                    }
                  >
                    {this.props.postToEdit
                      ? this.props.postToEdit.state.name
                      : "State"}
                  </option>
                  {this.state.filterdStates.map((option) => {
                    return (
                      <option key={option.id} value={option.id}>
                        {option.name}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className={classes.SearchNinputElementWraper}>
                <p className="mt-3">Area</p>
                <select
                  name="area_id"
                  onChange={(event) => {
                    this.selectAreasChangedHandler(
                      event.target.name,
                      event.target.value
                    );
                  }}
                >
                  <option
                    value={
                      this.props.postToEdit ? this.props.postToEdit.area.id : ""
                    }
                  >
                    {this.props.postToEdit
                      ? this.props.postToEdit.area.name
                      : "Area"}
                  </option>
                  {this.state.filterdAreas.map((option) => {
                    return (
                      <option key={option.id} value={option.id}>
                        {option.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <Map
              setCoordinate={this.setCoordinateHandler}
              coords={
                this.props.postToEdit
                  ? {
                      lat: this.props.postToEdit.lat,
                      lng: this.props.postToEdit.lng,
                    }
                  : null
              }
            />
            <div className={classes.Controls}>
              <button
                type="submit"
                className={`${classes.Btn}`} //${ServiceClasses.Btn}
              >
                Preview Post
              </button>
              {this.props.postToEdit && this.props.postMode && (
                <button
                  type="button"
                  className={`${classes.Btn} ${classes.Rest}`}
                  onClick={(event) => {
                    this.props.history.push("/Activites");
                    this.props.onDeleteActivityPost(this.props.postToEdit.id);
                  }}
                >
                  Delete
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    postingService: state.AddService.postingService,
    draftService: state.AddService.draftService,
    draftServiceId: state.AddService.draftServiceId,
    darfServiceError: state.AddService.darfServiceError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAddServiceToDraft: (serviceType, data, mediaData) => {
      dispatch(actionCreator.sendServiceAsDraft(serviceType, data, mediaData));
    },
    onSaveEditedPost: (vType, postId, data, media, vidMedia) => {
      dispatch(actionCreator.putEditPost(vType, postId, data, media, vidMedia));
    },
    onDeleteActivityPost: (id) => {
      dispatch(actionCreator.deleteAcitivityPost(id));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RentalOption);
